import React from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import Input from 'components/Input/Input';
import { cn } from 'components/lib/utils';

import { ApplicationIdRowProps } from '../types';

export const ApplicationIdRow: React.FC<ApplicationIdRowProps> = ({
  index,
  value,
  error,
  disabled = false,
  onChange,
  onBlur,
  onRemove,
  onCopy
}) => {
  const isFirst = index === 0;
  const showIcons = !disabled && (value.trim().length > 0 || Boolean(onRemove));

  return (
    <Input
      label={isFirst ? 'Application ID' : undefined}
      className={cn(
        '[&_.relative>div:last-child]:!w-auto',
        isFirst &&
          '[&>div:first-child]:items-center [&>div:first-child_label]:font-bold [&>div:first-child_label]:text-p-m [&>div:first-child]:mb-[30px] [&>div:first-child_label_i]:font-black'
      )}
      isRequired={isFirst}
      disabled={disabled}
      name={`appIds.${index}`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      placeholder="ID"
      state={error ? 'error' : 'default'}
      description={error}
      inputClassName={cn(
        showIcons && value.trim() && '!pr-16',
        error && 'border-base-destructive'
      )}
      rightIcon={
        showIcons ? (
          <div>
            {value.trim() && (
              <FontAwesomeIcon
                icon="fa-regular fa-copy"
                className="hover:text-base-foreground"
                onClick={onCopy}
              />
            )}
            {onRemove && (
              <FontAwesomeIcon
                icon="fa-regular fa-trash"
                className="hover:text-base-destructive"
                onClick={onRemove}
                data-testid={`apps-flyer-s2s-app-id-remove-${index}`}
              />
            )}
          </div>
        ) : undefined
      }
      rightIconStyles="flex items-center gap-2.5 cursor-pointer text-base-mutedForeground"
      dataTestId={`apps-flyer-s2s-app-id-${index}`}
      infoTooltipContent={
        isFirst
          ? "Your game's app identifier in the publishing store."
          : undefined
      }
      infoTooltipSide={isFirst ? 'top' : undefined}
    />
  );
};
